import { Trans } from '@lingui/react/macro';

import Error404 from '@/components/errors/Error404';

const PageNotFound = () => (
  <Error404
    title={<Trans>Page not found</Trans>}
    subtitle={<Trans>The page you are looking for does not exist or has moved.</Trans>}
  />
);

export default PageNotFound;
